var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivingView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3V15C20 16.6569 18.6569 18 17 18H15L15 9.80317L15 9.80096C14.999 9.38719 14.8679 8.97411 14.6058 8.64104C14.3441 8.30866 13.8976 8.00214 13.307 8H6.69701L6.69298 8.00001C6.10249 8.00215 5.65586 8.30855 5.39415 8.64104C5.13193 8.97418 5.00091 9.38736 5 9.80121V18H3C1.34315 18 0 16.6569 0 15V3ZM12.8453 10.4323C12.6812 10.2082 12.4011 10.0014 12.0307 10H7.88462L7.88209 10C7.51172 10.0014 7.23157 10.2081 7.06742 10.4323C6.90294 10.657 6.82076 10.9357 6.82019 11.2148V16.8769V16.8784C6.82083 17.1574 6.90304 17.436 7.06748 17.6607C7.23158 17.8848 7.51168 18.0915 7.88209 18.093H12.0281L12.0306 18.093C12.401 18.0915 12.6811 17.8848 12.8452 17.6607C13.0096 17.4361 13.0919 17.1576 13.0926 16.8786L13.0926 16.8769L13.0926 11.2161L13.0926 11.2146C13.0919 10.9355 13.0097 10.657 12.8453 10.4323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivingView);
export default __webpack_public_path__ + "static/media/driving-view.f5fd6b17263310236f909eb623937892.svg";
export { ForwardRef as ReactComponent };